/* eslint-disable no-use-before-define */
import moment from 'moment'
import remove from 'lodash/remove'

import { isEmptyText } from '@hw-core/utils'
import {
	extractInput,
	isListLenLimitExceeded,
	fetchApplications as _fetchApplications,
} from '@/shared/services/users'

/*
firebase index: collectionId, fields indexed
- search by mobile: users, isAdmin Ascending mobile Descending
- search by email: users, isAdmin Ascending email Descending
- search by last name: users, isAdmin Ascending lastName Descending

test cases
+-------------------------+-------------------------------------------+
| type in                 | expect to see unique matched results in   |
+=========================+===========================================+
| '125', '321'            | both mobile AND email cols                |
+-------------------------+-------------------------------------------+
| 'nghi' OR 'Nghi'        | both name AND email cols                  |
+-------------------------+-------------------------------------------+
| 'ali' OR 'Ali' OR 'ALI' | user (including last name) AND email cols |
+-------------------------+-------------------------------------------+
*/

async function fetchApplications(_ctx, queryParams) {
	const data = await _fetchApplications(queryParams)
	const updatedList = updateList(data, queryParams)
	return { data: updatedList, isMore: isListLenLimitExceeded(updatedList) }
}

function updateList(data, queryParams) {
	return filterByDate(data, queryParams)
}

function filterByDate(_data, queryParams) {
	const input = extractInput(queryParams)
	if (isEmptyText(input)) {
		const { seeking, seekingStart } = queryParams
		const queryStartDate = moment(seekingStart).add(moment().utcOffset() / 60, 'hours')
		if (seeking === 'periodic') {
			remove(_data, el => {
				const applicationEndDate = el?.application?.end?.toDate()
				return applicationEndDate <= new Date(queryStartDate)
			})
		} else if (seeking === 'long-term') {
			remove(_data, el => {
				const MAX_RANGE = 20
				const applicationStartDate = moment(el?.application?.start?.toDate())
				return Math.abs(applicationStartDate.diff(queryStartDate, 'days')) > MAX_RANGE
			})
		}
	}
	return _data
}

export {
	// eslint-disable-next-line import/prefer-default-export
	fetchApplications,
}
